<section class="contact-us__container">
    <div class="contact-us__container__thinking">
        <h3>Thinking about joining us?</h3>
        <p class="contact-us__container__thinking__content">
            <ng-content select="[role=thinking-content]"></ng-content>
        </p>
        <div class="contact-us__container__thinking__block">
            <div class="contact-us__container__thinking__block__icon">
                <nw-icon
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill
                        viewBox="0 0 24 24"
                        height="16"
                        width="16"
                        style="display: block"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <path
                            fill="currentColor"
                            d="M7.73 1.153A1.87 1.87 0 0 0 5.508.066L1.383 1.19A1.88 1.88 0 0 0 0 3c0 11.597 9.403 21 21 21a1.88 1.88 0 0 0 1.81-1.383l1.124-4.125a1.87 1.87 0 0 0-1.087-2.222l-4.5-1.875a1.87 1.87 0 0 0-2.17.544l-1.894 2.311A15.842 15.842 0 0 1 6.75 9.717l2.31-1.889a1.87 1.87 0 0 0 .545-2.17l-1.875-4.5v-.005Z"
                        />
                    </svg>
                </nw-icon>
            </div>
            <a
                class="contact-us__container__thinking__block__link"
                nw-link
                [href]="'tel:' + telephonenumber"
            >
                <ng-content select="[role=thinking-number]"></ng-content>
            </a>
            <p class="contact-us__container__thinking__block__text">
                <ng-content select="[role=thinking-number-label]"></ng-content>
            </p>
        </div>
        <div class="contact-us__container__thinking__block">
            <div class="contact-us__container__thinking__block__icon">
                <nw-icon
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill
                        viewBox="0 0 24 18"
                        height="12"
                        width="16"
                        style="display: block"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <path
                            fill="currentColor"
                            d="M2.25 0A2.25 2.25 0 0 0 .9 4.05l10.2 7.65a1.505 1.505 0 0 0 1.8 0l10.2-7.65A2.251 2.251 0 0 0 21.75 0H2.25ZM0 5.25V15c0 1.655 1.345 3 3 3h18c1.655 0 3-1.345 3-3V5.25L13.8 12.9a2.995 2.995 0 0 1-3.6 0L0 5.25Z"
                        />
                    </svg>
                </nw-icon>
            </div>
            <a
                class="contact-us__container__thinking__block__link"
                nw-link
                [href]="'mailto:' + adviceemailaddress"
            >
                <ng-content select="[role=thinking-email]"></ng-content>
            </a>
            <p class="contact-us__container__thinking__block__text">
                <ng-content select="[role=thinking-email-label]"></ng-content>
            </p>
        </div>
        <div class="contact-us__container__thinking__call-back">
            <h4>Request a call back</h4>
            <a nw-button [href]="scheduletimelink">Schedule a time</a>
        </div>
    </div>
    <div class="contact-us__container__already">
        <h3>Already a client?</h3>
        <p class="contact-us__container__already__content">
            <ng-content select="[role=already-content]"></ng-content>
        </p>
        <div class="contact-us__container__already__block">
            <div class="contact-us__container__already__block__icon">
                <nw-icon
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill
                        viewBox="0 0 24 24"
                        height="16"
                        width="16"
                        style="display: block"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <path
                            fill="currentColor"
                            d="M7.73 1.153A1.87 1.87 0 0 0 5.508.066L1.383 1.19A1.88 1.88 0 0 0 0 3c0 11.597 9.403 21 21 21a1.88 1.88 0 0 0 1.81-1.383l1.124-4.125a1.87 1.87 0 0 0-1.087-2.222l-4.5-1.875a1.87 1.87 0 0 0-2.17.544l-1.894 2.311A15.842 15.842 0 0 1 6.75 9.717l2.31-1.889a1.87 1.87 0 0 0 .545-2.17l-1.875-4.5v-.005Z"
                        />
                    </svg>
                </nw-icon>
            </div>
            <a
                class="contact-us__container__already__block__link"
                nw-link
                [href]="'tel:' + telephonenumber"
            >
                <ng-content select="[role=already-number]"></ng-content>
            </a>
            <p class="contact-us__container__already__block__text">
                <ng-content select="[role=already-number-label]"></ng-content>
            </p>
        </div>
        <div class="contact-us__container__already__block">
            <div class="contact-us__container__already__block__icon">
                <nw-icon
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill
                        viewBox="0 0 24 18"
                        height="12"
                        width="16"
                        style="display: block"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <path
                            fill="currentColor"
                            d="M2.25 0A2.25 2.25 0 0 0 .9 4.05l10.2 7.65a1.505 1.505 0 0 0 1.8 0l10.2-7.65A2.251 2.251 0 0 0 21.75 0H2.25ZM0 5.25V15c0 1.655 1.345 3 3 3h18c1.655 0 3-1.345 3-3V5.25L13.8 12.9a2.995 2.995 0 0 1-3.6 0L0 5.25Z"
                        />
                    </svg>
                </nw-icon>
            </div>
            <a
                class="contact-us__container__already__block__link"
                nw-link
                [href]="'mailto:' + clientserviceemailaddress"
            >
                <ng-content select="[role=already-email]"></ng-content>
            </a>
            <p class="contact-us__container__already__block__text">
                <ng-content select="[role=already-email-label]"></ng-content>
            </p>
        </div>
        <div class="contact-us__container__already__block">
            <div class="contact-us__container__already__block__icon">
                <nw-icon
                    ><svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill
                        viewBox="0 0 12 16"
                        height="16"
                        width="12"
                        style="display: block"
                        preserveAspectRatio="xMidYMid meet"
                        focusable="false"
                    >
                        <path
                            fill="currentColor"
                            d="M6.74 15.6C8.345 13.594 12 8.731 12 6c0-3.313-2.688-6-6-6-3.313 0-6 2.688-6 6 0 2.731 3.656 7.594 5.26 9.6a.944.944 0 0 0 1.48 0ZM6 4a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
                        />
                    </svg>
                </nw-icon>
            </div>
            <a
                class="contact-us__container__already__block__link"
                nw-link
                [href]="maplink"
            >
                <ng-content select="[role=already-address]"></ng-content>
            </a>
            <p class="contact-us__container__already__block__text">
                <ng-content select="[role=already-address-label]"></ng-content>
            </p>
        </div>
        @if (mapembed) {
            <iframe
                class="margin-top-l"
                [src]="mapembed | sanitizeUrl"
                width="100%"
                height="250"
                style="border: 0"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade"
            ></iframe>
        }
    </div>
</section>
